<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
    <g id="Nummer_3_bolletje" data-name="Nummer 3 bolletje" transform="translate(-727 -452)">
        <circle id="Ellipse_13" data-name="Ellipse 13" cx="13.5" cy="13.5" r="13.5" transform="translate(727 452)" fill="#0084c8"/>
        <text id="_3" data-name="3" transform="translate(736 471)" fill="#fff" font-size="16" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0">3</tspan></text>
    </g>
</svg>
